module.exports = __webpack_public_path__ + "img/menu-icon-chat.59597ad8.svg";